import Icon from 'components/Icon';
import useHomePath from 'hooks/useHomePath';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import HomeFilledIcon from '@mui/icons-material/Home';
import { env } from 'constants';

function HomeButton() {
  const { pathname } = useLocation();
  const homePath = useHomePath();

  if (env.IS_MARKETPLACE) {
    return null;
  }
  if (env.IS_CATERING) {
    const isActive = pathname === '/' || pathname.startsWith('/pwa');
    return (
      <Stack
        alignItems="center"
        component={Link}
        to={homePath}
        spacing="6px"
      >
        {
          isActive ? <Icon name="menu-filled" size={24} sx={{ color: 'primary.main' }} /> : <Icon name="menu-outlined" size={24} sx={{ color: 'text.secondary' }} />
        }
        <Typography variant="body-caption" color={isActive ? 'primary' : 'text.secondary'}>
          Menu
        </Typography>
      </Stack>
    );
  }
  // todo better path match
  const isActive = pathname.startsWith('/feed');
  return (
    <Stack
      alignItems="center"
      component={Link}
      to="/feed"
    >
      {
        isActive ? <HomeFilledIcon color="primary" /> : <HomeIcon sx={{ color: 'text.secondary' }} />
      }
      <Typography variant="caption" color={isActive ? 'primary' : 'text.secondary'}>
        Home
      </Typography>
    </Stack>
  );
}

export default HomeButton;
